"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

var _styles = _interopRequireDefault(require("./styles"));

var _placeholders = require("./placeholders");

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function getDefaultPlaceholder(type) {
  switch (type) {
    case 'email':
      return _placeholders.EMAIL;

    case 'phone':
      return _placeholders.PHONE_NUMBER;

    default:
      return '';
  }
} // Change all input types other than "number" into "text" to avoid the browser rendering a special input.


function getInputType(type) {
  switch (type) {
    case 'number':
      return 'number';

    default:
      return 'text';
  }
}

var TextInput = function TextInput(_ref) {
  var classes = _ref.classes,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      errorText = _ref.errorText,
      showError = _ref.showError,
      _onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      inputRef = _ref.inputRef,
      active = _ref.active,
      value = _ref.value,
      type = _ref.type,
      inputElAttributes = _ref.inputElAttributes,
      isTextArea = _ref.isTextArea,
      uncontained = _ref.uncontained,
      rest = _objectWithoutProperties(_ref, ["classes", "placeholder", "disabled", "errorText", "showError", "onChange", "onFocus", "onBlur", "leftIcon", "rightIcon", "inputRef", "active", "value", "type", "inputElAttributes", "isTextArea", "uncontained"]);

  var defaultPlaceholder = (0, _lodash.isEmpty)(placeholder) ? getDefaultPlaceholder(type) : placeholder;
  var defaultInputType = getInputType(type);

  var inputProps = _objectSpread({}, inputElAttributes, {
    className: (0, _classnames["default"])(classes.input, active ? classes.inputActive : null),
    type: defaultInputType,
    placeholder: defaultPlaceholder,
    ref: inputRef,
    onChange: function onChange(e) {
      return _onChange(e, e.target.value);
    },
    onFocus: onFocus,
    onBlur: onBlur,
    value: value,
    disabled: disabled
  });

  return _react["default"].createElement("div", _extends({
    className: classes.root
  }, rest), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.inputContainer, disabled ? classes.disabled : null)
  }, leftIcon && _react["default"].createElement("div", {
    className: classes.leftIcon
  }, leftIcon), isTextArea ? _react["default"].createElement("textarea", inputProps) : _react["default"].createElement("input", inputProps), rightIcon && _react["default"].createElement("div", {
    className: classes.rightIcon
  }, rightIcon)), showError ? _react["default"].createElement("div", {
    className: classes.errorText
  }, errorText) : null);
};

TextInput.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Placeholder text for input */
  placeholder: _propTypes["default"].string,

  /** Value for the input */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Bool flag to enable/disable the input */
  disabled: _propTypes["default"].bool,

  /** Bool flag to show/hide error */
  showError: _propTypes["default"].bool,

  /** Error text to be shown below the input */
  errorText: _propTypes["default"].string,

  /** TextInput onChange callback */
  onChange: _propTypes["default"].func,

  /** TextInput onFocus callback */
  onFocus: _propTypes["default"].func,

  /** TextInput onBlur callback */
  onBlur: _propTypes["default"].func,

  /** Icon to be shown inside the Textinput component on the left of the input */
  leftIcon: _propTypes["default"].node,

  /** Icon to be shown inside the Textinput component on the right of the input */
  rightIcon: _propTypes["default"].node,

  /** Callback to obtain a ref to the input */
  inputRef: _propTypes["default"].func,

  /** Bool flag to maintain active styling on TextInput even when not in focus */
  active: _propTypes["default"].bool,

  /**
   * Type for the input component, can be any type from https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Input#%3Cinput%3E_types
   * This mainly affects the default placeholder. All types other than "text" or "number" will be changed to "text" or "number" (whichever is more appropriate.)
   * This is to avoid the browser rendering a special input in place of a "text" or "number" input.
   */
  type: _propTypes["default"].string,

  /** Extra attributes to be passed to the input element */
  inputElAttributes: _propTypes["default"].shape(),

  /** Use `textarea` as underlying html element rather than `input` */
  isTextArea: _propTypes["default"].bool,

  /** Uncontained TextInputs can be used for gridded forms */
  uncontained: _propTypes["default"].bool
};
TextInput.defaultProps = {
  value: '',
  disabled: false,
  showError: false,
  errorText: '',
  onChange: function onChange() {
    return undefined;
  },
  onFocus: function onFocus() {
    return undefined;
  },
  onBlur: function onBlur() {
    return undefined;
  },
  leftIcon: null,
  rightIcon: null,
  inputRef: function inputRef() {
    return undefined;
  },
  active: false,
  type: 'text',
  inputElAttributes: {},
  isTextArea: false,
  uncontained: false
};

var _default = (0, _withStyles["default"])(_styles["default"])(TextInput);

exports["default"] = _default;